import { supabase } from '../lib/supabase';

// This function sets up the avatars bucket in Supabase Storage
// Run this once to create the bucket with proper policies
export const setupAvatarStorage = async () => {
  console.log('=== Setting up Avatar Storage ===');
  
  try {
    // Check if bucket exists
    const { data: buckets, error: listError } = await supabase.storage.listBuckets();
    
    if (listError) {
      console.error('Error listing buckets:', listError);
      return { success: false, error: listError };
    }
    
    const avatarBucketExists = buckets?.some(bucket => bucket.name === 'avatars');
    
    if (avatarBucketExists) {
      console.log('✅ Avatars bucket already exists');
      return { success: true, message: 'Bucket already exists' };
    }
    
    // Create the avatars bucket
    const { data, error } = await supabase.storage.createBucket('avatars', {
      public: true,
      allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
      fileSizeLimit: 5242880 // 5MB
    });
    
    if (error) {
      console.error('Error creating bucket:', error);
      return { success: false, error };
    }
    
    console.log('✅ Avatars bucket created successfully');
    
    // Note: RLS policies should be set up in Supabase dashboard
    console.log(`
    ⚠️ IMPORTANT: Set up RLS policies in Supabase dashboard:
    
    1. Go to Storage > Avatars bucket > Policies
    2. Add these policies:
    
    SELECT Policy (Public):
    - Policy name: "Public Avatar Access"
    - Target roles: anon, authenticated
    - WITH CHECK: true
    
    INSERT Policy (Authenticated users can upload their own):
    - Policy name: "Users can upload own avatar"
    - Target roles: authenticated
    - WITH CHECK: (auth.uid()::text = storage.foldername(name))
    
    UPDATE Policy (Users can update their own):
    - Policy name: "Users can update own avatar"
    - Target roles: authenticated
    - USING: (auth.uid()::text = storage.foldername(name))
    - WITH CHECK: (auth.uid()::text = storage.foldername(name))
    
    DELETE Policy (Users can delete their own):
    - Policy name: "Users can delete own avatar"
    - Target roles: authenticated
    - USING: (auth.uid()::text = storage.foldername(name))
    `);
    
    return { success: true, data };
  } catch (error) {
    console.error('Setup error:', error);
    return { success: false, error };
  }
};

// Make available in browser console for manual setup
if (typeof window !== 'undefined') {
  window.setupAvatarStorage = setupAvatarStorage;
  console.log('Avatar storage setup available: window.setupAvatarStorage()');
}